import { render, staticRenderFns } from "./FlowNegativeList.vue?vue&type=template&id=73741f70&scoped=true&"
import script from "./FlowNegativeList.vue?vue&type=script&lang=js&"
export * from "./FlowNegativeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73741f70",
  null
  
)

export default component.exports